export class StaticPagesCookies {
  constructor () {
    this.banner = document.querySelector('.cookie-notice-container');
    this.displayMobileButton = this.banner && document.querySelector('.cookie-mobile-button');
    this.bannerAcceptButton = this.banner && this.banner.querySelector('[data-toggle="accept"]');
    this.desktopMinimumScreenSize = 1024;
  }

  hasAcceptedCookies () {
    return localStorage.getItem('cookies');
  };

  addListenersToButtons () {
    this.banner && this.bannerAcceptButton.addEventListener('click', () => {
      this.toggleActiveClasses(this.banner);
      localStorage.setItem('cookies', 'accepted');
    }, { once: true });

    this.banner && this.displayMobileButton.addEventListener('click', () => {
      this.toggleActiveClasses(this.banner);
      this.toggleActiveClasses(this.displayMobileButton);
    }, { once: true });
  };

  toggleActiveClasses(element) {
    element.classList.toggle('active');
  }

  displayCookies () {
    if (this.banner && !this.hasAcceptedCookies()) {
      window.innerWidth > this.desktopMinimumScreenSize
        ? this.banner.classList.add('active')
        : this.displayMobileButton.classList.add('active')
    }
  };
}
